import React from 'react';

import PropTypes from 'prop-types';

export const FeaturedImage = (props) => {
    const { imgUrl } = props;
    if (!imgUrl || imgUrl.includes('banner-placeholder')) {
        return null;
    }

    return (
        <div
            className="post_page_featured_image mb-2"
            role="img"
            aria-label="Post Page Featured Image"
            style={{ backgroundImage: `url(${imgUrl})` }}
        />
    );
};

FeaturedImage.propTypes = {
    imgUrl: PropTypes.string.isRequired,
};

